'use client'

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { cn } from '@/lib/utils'
import Certificate from './certificate'
import Content from './content'
import Faq from './faq'

const tabItems = [
  { name: 'Conteúdo do Curso', value: 'content' },
  { name: 'Nosso Certificado', value: 'certificate' },
  { name: 'Dúvidas Frequentes', value: 'faq' },
]

export default function CourseInformationNavigation({ course, unity }) {
  const hasMec = unity.details.metadata.has_mec
  const isFreeCourse = course.billing_type === 'postpaid'

  return (
    <Tabs className="w-full" defaultValue="content">
      <div className="md:relative" id="info">
        <div
          aria-hidden
          className="pointer-events-none absolute inset-x-0 bottom-0 z-0 hidden h-[3px] bg-primary-100 md:block"
        />
        <TabsList
          className={cn(
            'relative z-[1] mt-3 flex h-auto w-full flex-col gap-3 bg-transparent p-0',
            'md:mt-0 md:flex-row md:flex-wrap md:items-stretch md:justify-between md:gap-0',
            'rounded-none border-0'
          )}
        >
          {tabItems.map(option => (
            <TabsTrigger
              className={cn(
                'group relative flex w-full justify-start border-[#877E94]/30 border-b-2 py-2 text-start font-bold text-[#877E94] text-lg opacity-30 transition-all',
                'after:-bottom-0.5 after:absolute after:left-0 after:block after:h-0.5 after:w-0 after:bg-primary-600 after:transition-all after:duration-300 after:ease-out after:content-[""]',
                'data-[state=active]:text-gray-800 data-[state=active]:opacity-100 data-[state=active]:after:w-full',
                'md:inline-flex md:h-auto md:w-auto md:flex-col md:items-center md:justify-end md:border-0 md:py-2 md:font-medium md:text-gray-800 md:text-lg md:opacity-100 md:after:hidden',
                'hover:text-primary-700 data-[state=active]:bg-transparent data-[state=active]:font-semibold data-[state=active]:text-primary-700 md:data-[state=active]:text-primary-700'
              )}
              key={option.value}
              type="button"
              value={option.value}
            >
              {option.name}
              <span
                aria-hidden
                className="absolute bottom-1 left-0 z-[2] hidden h-[3px] w-full rounded-full bg-primary-600 opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-100 group-data-[state=active]:opacity-100 md:block"
              />
            </TabsTrigger>
          ))}
        </TabsList>
      </div>

      <TabsContent className="mt-0" value="content">
        <Content product={course} />
      </TabsContent>
      <TabsContent className="mt-0" value="certificate">
        <Certificate
          amount={course.amount}
          isFreeCourse={isFreeCourse}
          unity={unity}
          workloads={course.workloads}
        />
      </TabsContent>
      <TabsContent className="mt-0" value="faq">
        <Faq hasMec={hasMec} product={course} />
      </TabsContent>
    </Tabs>
  )
}
